import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./planing.css";
import star from "../../assests/Simplification.svg";
import ContactFormModal from "../header/ContactFormModal"; // import your modal
import banner from "../../assests/Banner-home.svg"
import { useNavigate } from "react-router-dom";

const words = [
  { text: "Software", color: "#4CACDB" },
  { text: "Product", color: "#FDC90B" },
  { text: "Business", color: "#E43025" },
];

const Planing = () => {
    const navigate = useNavigate();

  const [index, setIndex] = useState(0);
  // const [showModal, setShowModal] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);  // State to control modal

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="home" className="hero text-center">
      <div className="container hero-content">


{/* <div className="d-flex justify-content-center">
  <div className="banner px-3 py-1 d-flex align-items-center shadow-sm position-relative">
    <span className="me-1 fw-bold">New:</span>
    <span className="highlight fw-bold ms-1">WayDone AI</span>&nbsp;is Live!
    <img src={star} alt="star" className="star-floating" />
  </div>
</div> */}


        {/* <div className="star-images">
          <img src={banner} alt="star" className="star-images" />
        </div> */}

        <h2 className="fw-bold">
          Elevate Your{" "}
          <span className="highlights">
            <span
              key={index}
              className="carousel-word"
              style={{ color: words[index].color }}
            >
              {words[index].text}
            </span>
          </span>{" "}
          with Next Gen AI
        </h2>
        <h2 className="fw-bold mt-2">XYLOITE TECHNOLOGIES</h2>

        <p className="subtitle mx-auto mt-3">
          Tech Synergy Beyond Boundaries
        </p>

        <div className="d-flex justify-content-center gap-3 mt-3">
    <Button 
      className="btn-touch" 
      onClick={() => navigate("/Contact-Us")}
    >
      Get in Touch
    </Button>
           <Button 
  className="btn btn-outline px-4" 
  onClick={() => window.open("https://waydone.ai", "_blank")}
>
  Our Product
</Button>

        </div>

        {/* Render the modal */}
{showContactForm && <ContactFormModal onClose={() => setShowContactForm(false)} />}
      </div>
    </section>
  );
};

export default Planing;
